import type { PillTone } from "@astrum/ui";

export type GoalStatus = "on_track" | "at_risk" | "off_track" | "achieved" | "missed";

export const GOAL_STATUS_OPTIONS: Array<{ value: GoalStatus; label: string }> = [
  { value: "on_track", label: "On track" },
  { value: "at_risk", label: "At risk" },
  { value: "off_track", label: "Off track" },
  { value: "achieved", label: "Achieved" },
  { value: "missed", label: "Missed" },
];

const TONES: Record<GoalStatus, PillTone> = {
  on_track: "ok",
  at_risk: "warn",
  off_track: "danger",
  achieved: "accent",
  missed: "neutral",
};

export const goalStatusTone = (status: string): PillTone => TONES[status as GoalStatus] ?? "neutral";

export const goalStatusLabel = (status: string): string =>
  GOAL_STATUS_OPTIONS.find((o) => o.value === status)?.label ?? status;

/** "42%", or a dash when there is nothing to measure yet (not 0%). */
export const progressLabel = (progress: number | null): string => (progress === null ? "–" : `${progress}%`);

/** "50 of 200 leads", for a manual metric; null for anything else. */
export function metricLabel(g: {
  measurement: string;
  currentValue: number | null;
  targetValue: number | null;
  unit: string | null;
}): string | null {
  if (g.measurement !== "manual" || g.currentValue === null || g.targetValue === null) return null;
  return `${g.currentValue} of ${g.targetValue}${g.unit ? ` ${g.unit}` : ""}`;
}
